import type { IEventType } from '@/interfaces'

export class EventType implements IEventType {
	id: number
	name: string
	constructor({ id, name }: IEventType) {
		this.id = id
		this.name = name
	}
}
